import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import { IconWrapper, Title, MainIcon } from '../../SharedStyles'
import Icon from 'components/common/Icon/Icon'
import { SHOP_TIRES_TITLE } from '../../constant'
import { APPOINTMENT_ALT } from 'components/BOTRegionalDetails/constants'

const NewValuePropositionBig = ({
  asset,
  title,
  description,
  alt,
  onMouseEnterHandler,
  onMouseLeaveHandler,
  isHover,
  click = () => {},
  hasActiveVehicle,
  activeVehicle: {
    vehicleName
  },
  isTrailer,
  isBlackFridayPage,
  className
}) =>
  <ValueProposition
    className={ className }
    tabIndex="0"
    alt={ alt }
    onMouseEnter={ () => onMouseEnterHandler(alt) }
    onMouseLeave={ onMouseLeaveHandler }
    onClick={ click }>
    <IconWrapper className="main-icon-wrapper">
      <MainIcon className="main-icon" asset={ asset } />
    </IconWrapper>
    <TextWrapper className="tile-text-wrapper">
      <CustomTitle className="tile-title">{ title }</CustomTitle>
      {description && (
        <Description className="tile-description">{ description }</Description>
      )}
      { (hasActiveVehicle && title === SHOP_TIRES_TITLE && !isTrailer)
        && <ActiveVehilceTitle>{ vehicleName }</ActiveVehilceTitle> }
    </TextWrapper>
    {isBlackFridayPage ? (
      <CustomIcon className="arrow-icon" asset={ isHover ? 'arrow-right-white' : 'arrow-right-bright-red' } width={ 13 } />
    ) : (
      <CustomIcon className="arrow-icon" asset={ isHover ? 'arrow-right-white' : 'arrow-right' } width={ 10 } />
    )}

  </ValueProposition>

NewValuePropositionBig.propTypes = {
  activeVehicle: PropTypes.shape({
    vehicleName: PropTypes.string
  }),
  alt: PropTypes.string,
  asset: PropTypes.string,
  className: PropTypes.string,
  click: PropTypes.func,
  description: PropTypes.string,
  hasActiveVehicle: PropTypes.bool,
  isBlackFridayPage: PropTypes.bool,
  isHover: PropTypes.bool,
  isTrailer: PropTypes.bool,
  onMouseEnterHandler: PropTypes.func,
  onMouseLeaveHandler: PropTypes.func,
  title: PropTypes.string
}

export default NewValuePropositionBig

const ValueProposition = styled.div`
  background: ${Theme.colors.white};
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  cursor: pointer;
  padding: 34px 25px 32px;
  margin-bottom: 17px;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  ${Media.desktop`
    &:hover {
      background: ${Theme.colors.bright_red_new};
    }

    &:hover div {
      color: ${Theme.colors.white};
    }
  `}

  ${({ alt }) => alt !== APPOINTMENT_ALT && css`
    @media (max-width: 450px) {
      padding: 20px 25px 20px 15px;
      margin-bottom: 10px;
    }
  `}
`

const TextWrapper = styled.div`
  margin-left: 15px;

  @media (max-width: 450px) {
    margin-left: 10px;
  }
`

const CustomTitle = styled(Title)`
  margin-bottom: 3px;
  ${Mixin.font.GothamBold(20)};

  @media (max-width: 500px) {
    ${Mixin.font.GothamBold(18)};
  }

  @media (max-width: 400px) {
    ${Mixin.font.GothamBold(13)};
  }
`

const Description = styled.div`
  color: ${Theme.colors.medium_grey};
  max-width: 270px;
  ${Mixin.font.GothamMedium(13, 500)};

  @media (max-width: 450px) {
    ${Mixin.font.GothamMedium(12, 500)};
  }
`

const CustomIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;

  @media (max-width: 450px) {
    right: 10px;
  }
`

const ActiveVehilceTitle = styled.div`
  margin-top: 3px;
  color: ${Theme.colors.blue};
  ${Mixin.font.GothamBook(13)};
`
